import React from "react";
import { Box, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { HomePageIncludedItemType } from "../../../../shared/home-page-models";
import { useTranslation } from "react-i18next";
import Title1 from "../../../../components/base/Title1";
import NewsCardList from "../../../../components/card/NewsCardList";
import ReadMore from "../../../../components/read-more/read-more";
import { useHistory } from "react-router-dom";

const LatestNews: React.FC = () => {
  const homePageData = useSelector((state: RootState) => state.homePage.data);
  const isFetching = useSelector(
    (state: RootState) => state.homePage.isFetching
  );
  const { t } = useTranslation();
  const history = useHistory();

  const threePosts: any =
    homePageData?.included
      ?.filter((included) => included.type === HomePageIncludedItemType.Posts)
      .slice(0, 3) ?? [];

  if (threePosts?.length > 0) {
    return (
      <Box my={8}>
        <Stack alignItems="center">
          <Title1 textAlign="center" maxWidth={650}>
            {t("HOME_NEWS_SECTION_TITLE")}
          </Title1>
          <NewsCardList 
            isFetching={isFetching} 
            news={threePosts.map((post: any) => {
              const news: any = homePageData.included?.find((i: any) => i.type === 'news' && post.relationships?.news.data.id === i.id);

              return {
                ...post,
                newsCategoryHr: news?.attributes.newsCategory,
                newsCategoryEn: news?.attributes.newsCategoryEn,
              };
            })} 
          />
          <ReadMore onClick={() => history.push("/news")} />
        </Stack>
      </Box>
    );
  }
  return null;
};

export default LatestNews;
